"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AvatarContainer;
exports.SIZE_TO_FONT_SIZE = exports.SIZE_TO_WIDTH_HEIGHT = exports.AvatarSize = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("../../theme/colors");

var _layout = _interopRequireDefault(require("./layout"));

var _SIZE_TO_WIDTH_HEIGHT, _SIZE_TO_FONT_SIZE;

var AvatarSize;
exports.AvatarSize = AvatarSize;

(function (AvatarSize) {
  AvatarSize["Xsmall"] = "xsmall";
  AvatarSize["Small"] = "small";
  AvatarSize["Medium"] = "medium";
  AvatarSize["Large"] = "large";
})(AvatarSize || (exports.AvatarSize = AvatarSize = {}));

var SIZE_TO_WIDTH_HEIGHT = (_SIZE_TO_WIDTH_HEIGHT = {}, (0, _defineProperty2["default"])(_SIZE_TO_WIDTH_HEIGHT, AvatarSize.Xsmall, '1.250rem'), (0, _defineProperty2["default"])(_SIZE_TO_WIDTH_HEIGHT, AvatarSize.Small, '2.286rem'), (0, _defineProperty2["default"])(_SIZE_TO_WIDTH_HEIGHT, AvatarSize.Medium, '2.857rem'), (0, _defineProperty2["default"])(_SIZE_TO_WIDTH_HEIGHT, AvatarSize.Large, '5.143rem'), _SIZE_TO_WIDTH_HEIGHT);
exports.SIZE_TO_WIDTH_HEIGHT = SIZE_TO_WIDTH_HEIGHT;
var SIZE_TO_FONT_SIZE = (_SIZE_TO_FONT_SIZE = {}, (0, _defineProperty2["default"])(_SIZE_TO_FONT_SIZE, AvatarSize.Xsmall, '0.5714rem'), (0, _defineProperty2["default"])(_SIZE_TO_FONT_SIZE, AvatarSize.Small, '1rem'), (0, _defineProperty2["default"])(_SIZE_TO_FONT_SIZE, AvatarSize.Medium, '1.143rem'), (0, _defineProperty2["default"])(_SIZE_TO_FONT_SIZE, AvatarSize.Large, '2rem'), _SIZE_TO_FONT_SIZE);
exports.SIZE_TO_FONT_SIZE = SIZE_TO_FONT_SIZE;

function AvatarContainer(_ref) {
  var backgroundColor = _ref.backgroundColor,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? AvatarSize.Medium : _ref$size,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["backgroundColor", "size"]);
  var defaultBackgroundColor = (0, _colors.getRandomColor)();
  return /*#__PURE__*/_react["default"].createElement(_layout["default"], Object.assign({}, rest, {
    size: size,
    backgroundColor: backgroundColor || defaultBackgroundColor
  }));
}